import { Button, Checkbox, Col, Form, Input, Row, Spin } from 'antd';
import React, { useEffect, useState } from 'react';

import useTranslate from '@core/hooks/useTranslate';
import { DownloadOutlined } from '@ant-design/icons';
import SubmitButton from '@root/core/components/Button';
import ButtonSubmit from './ButtonSubmit';
import Popup from '@root/core/components/Popup';
import CountryPhoneInput from '@root/core/components/CountryPhoneInput';

interface Props {
  formData:
    | {
        firstName: string;
        lastName: string;
        contactNumber: string;
        countryCode: string;
        companyCountryCode: string;
        email: string;
        password: string;
        companyName: string;
        address: string;
        phoneNumber: string;
        businessLicense: {
          url: string;
          fileName?: string;
        };
        saleCountry: string;
        monthlyShipment: string;
        numberOfProduct: string;
        amazonSellerId: string;
        state: string;
        companyPhoneNumber: string;
        detailAddress: string;
        detailAddress2: string;
        detailAddress3: string;
        stateAddress: string;
        city: string;
        country: string;
        companyAddress: string;
        saleCategory: string[];
        saleChannels: string[];
        postalCode: string;
      }
    | undefined;
  loading: boolean;
}

const FormSellerInfo = ({ formData, loading }: Props) => {
  const [form] = Form.useForm();
  useEffect(() => {
    form.setFieldsValue({
      lastName: formData?.lastName,
      firstName: formData?.firstName,
      contactNumber: formData?.contactNumber,
      countryCode: formData?.countryCode,
      companyCountryCode: formData?.companyCountryCode,
      email: formData?.email,
      password: formData?.password,
      companyName: formData?.companyName,
      address: formData?.address,
      phoneNumber: formData?.phoneNumber,
      companyPhoneNumber: formData?.companyPhoneNumber,
      businessLicense: formData?.businessLicense?.fileName,
      saleCountry: formData?.saleCountry,
      monthlyShipment: formData?.monthlyShipment?.replace('?', '건'),
      numberOfProduct: formData?.numberOfProduct?.replace('?', '개'),
      amazonSellerId: formData?.amazonSellerId,
      detailAddress: formData?.detailAddress,
      detailAddress2: formData?.detailAddress2,
      detailAddress3: formData?.detailAddress3,
      city: formData?.city,
      stateAddress: formData?.stateAddress,
      country: formData?.country,
      companyAddress: formData?.companyAddress,
      saleCategory: formData?.saleCategory,
      saleChannels: formData?.saleChannels,
      postalCode: formData?.postalCode
    });
  });

  const [t] = useTranslate();

  const onFinish = (values: any) => {};

  const onFinishFailed = (errorInfo: any) => {};

  const downloadFile = (url: any) => {
    window.location.href = url;
  };

  return (
    <>
      <div
        style={{
          padding: '1rem',
          backgroundColor: 'white'
        }}
        id="busk-DetailForm"
      >
        <Form
          name="basic"
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          form={form}
        >
          <Row gutter={24}>
            {/* Left Form */}
            <Col flex={'1'}>
              <Row gutter={24}>
                <Col span={12}>
                  <Form.Item label="성" name="lastName">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="이름" name="firstName">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <Form.Item>
                    <Input.Group size="large">
                      <Row gutter={20}>
                        <Col
                          id="form-country-container"
                          className="country-phone-container"
                        >
                          <CountryPhoneInput
                            placeholder="Please enter number only"
                            title="연락처"
                            disabled={true}
                            name="phoneNumber"
                            defaultCode={formData?.countryCode}
                            onchange={(value: any) => {
                              form.setFieldsValue({ countryCode: value });
                            }}
                            phoneNumberRules={[
                              {
                                required: true,
                                message: 'Phone number is required'
                              }
                            ]}
                          />
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Col>
              </Row>
            </Col>

            {/* Right Form */}
            <Col flex={'1'}>
              <Row>
                <Col span={24}>
                  <Form.Item label="사업자명" name="companyName">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item label="사업장 국가" name="country">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col flex={'1'}>
              <Row>
                <Col span={24}>
                  <Form.Item label="주소1" name="detailAddress">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item label="도시명" name="city">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Col>

            <Col flex={'1'}>
              <Row>
                <Col span={24}>
                  <Form.Item label="주소2" name="detailAddress2">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item label="지역명" name="stateAddress">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Col>

            <Col flex={'1'}>
              <Row>
                <Col span={24}>
                  <Form.Item label="주소3" name="detailAddress3">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item label="우편번호" name="postalCode">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={24}>
            {/* Left Form */}
            <Col flex={'1'}>
              <Row>
                <Col span={24}>
                  <Form.Item label="이메일" name="email">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <Form.Item label="판매국가" name="saleCountry">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item label="아마존 계정 정보" name="amazonSellerId">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Col>

            {/* Right Form */}
            <Col flex={'1'}>
              <Row>
                <Col span={24}>
                  <Form.Item>
                    <Input.Group size="large">
                      <Row gutter={20}>
                        <Col
                          id="form-country-container"
                          className="country-phone-container"
                        >
                          <CountryPhoneInput
                            placeholder="Please enter number only"
                            title="사업자 연락처"
                            disabled={true}
                            name="companyPhoneNumber"
                            defaultCode={formData?.companyCountryCode}
                            onchange={(value: any) => {
                              form.setFieldsValue({
                                companyCountryCode: value
                              });
                            }}
                            phoneNumberRules={[
                              {
                                required: true,
                                message: 'Phone number is required'
                              }
                            ]}
                          />
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Col>
              </Row>

              <Row align="bottom" gutter={32}>
                <Col flex={1}>
                  <Form.Item label="사업자등록증" name="businessLicense">
                    <Input />
                  </Form.Item>
                </Col>
                <Col flex="150px">
                  <Form.Item>
                    <Button
                      className="busk-download"
                      type="primary"
                      shape="round"
                      size="middle"
                      icon={<DownloadOutlined />}
                      onClick={() =>
                        downloadFile(formData?.businessLicense?.url)
                      }
                    >
                      다운로드
                    </Button>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col span={12}>
                  <Form.Item label="판매 카테고리" name="saleCategory">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="판매 채널" name="saleChannels">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col span={12}>
                  <Form.Item label="월 출고 건수" name="monthlyShipment">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="운영상품 수" name="numberOfProduct">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row justify="end" style={{ marginTop: '3rem' }}>
            <Form.Item>
              <Row gutter={12}>
                <Col>
                  <ButtonSubmit type="거절" state={formData?.state} />
                </Col>
                <Col>
                  <ButtonSubmit type="승인" state={formData?.state} />
                </Col>
              </Row>
            </Form.Item>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default FormSellerInfo;
